// extracted by mini-css-extract-plugin
module.exports = {"relatedSearchImages":"_35_j-","relatedSearchImage":"_1PFTC"};